import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  title = 'zeeker-web';
  showArrow = false;

  goToTop() {
    window.scrollTo(0, 0);
  }

  scrollHidden() {
    // debugger;
    return this.showArrow = window.scrollY === 0;
  }
}
